import { InputModel } from '../input/input.model';
import { RequiredModel } from '../input/rules/implementations/required.model';
import { CPFModel } from '../input/rules/implementations/cpf.model';
import { InputSelectModel } from '../input-select/inputSelect.model';
import { CurrencyModel } from '../input/rules/implementations/currency.model';
import { TextareaModel } from '../textarea/textarea.model';
import { AreaCodeModel } from '../input/rules/implementations/areaCode.model';
import { PhoneModel } from '../input/rules/implementations/phone.model';

export class ReembolsoModel {
  Valor: number;
  ValorToShow: string;
  Observacao: string;
  ContaBancaria = new ContaBancaria();
  ddd: string;
  celular: string;
  ChavePix: string;

  valorInputModel = new InputModel(false, false, 'tel', 'R$ 0,00', [], new CurrencyModel());
  ObservacaoTextareaModel = new TextareaModel(false, false, 'Observação', []);
  dddInputModel = new InputModel(false, false, 'tel', null, [new RequiredModel()], new AreaCodeModel());
  celularInputModel = new InputModel(false, false, 'tel', null, [new RequiredModel()], new PhoneModel());
  ChavePixInputModel = new InputModel(false, false, 'text', null, []);

  constructor(tipoReembolso: string) {
    if (tipoReembolso === '2') {
      this.valorInputModel.setReadOnly();
      this.valorInputModel.setIsInputCurrencyReembolso();
    }
  }
}

export class ContaBancaria {
  NomeTitular: string;
  CPF: string;
  CodigoBanco: string;
  Agencia: string;
  AgenciaDigito: string;
  Conta: string;
  ContaDigito: string;
  Tipo: string;
  DeveSalvar: boolean;

  NomeTitularInputModel = new InputModel(false, false, 'text', null, [new RequiredModel()]);
  CPFInputModel = new InputModel(false, false, 'text', null, [new RequiredModel(), new CPFModel()], new CPFModel());
  CodigoBancoInputModel: Array<InputSelectModel> = new Array<InputSelectModel>();
  AgenciaInputModel = new InputModel(false, false, 'text', null, [new RequiredModel()]);
  AgenciaDigitoInputModel = new InputModel(false, false, 'text', null, []);
  ContaInputModel = new InputModel(false, false, 'text', null, [new RequiredModel()]);
  ContaDigitoInputModel = new InputModel(false, false, 'text', null, [new RequiredModel()]);

  constructor() {
    this.CPFInputModel.setReadOnly();
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/reembolso/reembolso.model.ts